import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from '../styles/Header.module.css';
import SettingsSharpIcon from '@mui/icons-material/SettingsSharp';

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className={`${styles.header} ${styles.stickyHeader}`}>
      <nav className={styles.nav}>
        <ul className={styles.navList}>
          <li><Link to="/">Home</Link></li>
          {user && <li><Link to="/weekly-picks">Weekly Picks</Link></li>}
          {user && <li><Link to="/leaderboard">League Stats</Link></li>}
          {user && user.role === 'admin' && (
            <li><Link to="/admin-dashboard">Admin Dashboard</Link></li>
          )}
        </ul>
      </nav>
      <div className={styles.userSection}>
        {user ? (
          <>
            <Link to="/user-profile">Hello, {user.username}</Link>
            <Link to="/user-settings"><SettingsSharpIcon /></Link>
            <button onClick={handleLogout}>Logout</button>
          </>
        ) : (
          <Link to="/login">Login</Link>
        )}
      </div>
    </header>
  );
};

export default Header;
